// Datos y textos comunes de las fichas de leads y clientes (C3D-46).

export const LEAD_STAGES = [
    { value: "prospecto", label: "Prospecto", tone: "neutral" },
    { value: "contactado", label: "Contactado", tone: "info" },
    { value: "lead", label: "Lead", tone: "warning" },
    { value: "convertido", label: "Convertido", tone: "success" },
    { value: "perdido", label: "Perdido", tone: "error" },
];

export const LEAD_SOURCES = [
    { value: "manual", label: "Manual" },
    { value: "maps", label: "Mapas" },
    { value: "instagram", label: "Instagram" },
    { value: "qr", label: "QR" },
    { value: "formulario", label: "Formulario" },
    { value: "tienda", label: "Tienda" },
    { value: "visor_publico", label: "Visor público" },
    { value: "otro", label: "Otro" },
];

export const CLIENT_STATUSES = [
    { value: "LEAD", label: "Lead", tone: "warning" },
    { value: "ACTIVE", label: "Activo", tone: "success" },
    { value: "INACTIVE", label: "Inactivo", tone: "neutral" },
];

export const PHONE_TYPES = [
    { value: "MOBILE", label: "Móvil" },
    { value: "WORK", label: "Trabajo" },
    { value: "HOME", label: "Particular" },
    { value: "OTHER", label: "Otro" },
];

export const SOCIAL_PLATFORMS = [
    { value: "INSTAGRAM", label: "Instagram" },
    { value: "FACEBOOK", label: "Facebook" },
    { value: "LINKEDIN", label: "LinkedIn" },
    { value: "TWITTER", label: "X / Twitter" },
    { value: "OTHER", label: "Otra" },
];

export const optionFor = (options, value) => options.find((option) => option.value === value);
export const labelFor = (options, value) => optionFor(options, value)?.label || value || "";

export const leadName = (lead) => (
    lead?.company_name || lead?.contact_name || lead?.email || lead?.phone || (lead?.id ? `Lead #${lead.id}` : "")
);

export const clienteName = (cliente) => (
    cliente?.company_name
    || [cliente?.nombre, cliente?.apellido].filter(Boolean).join(" ")
    || cliente?.email
    || ""
);

export const userLabel = (user) => {
    if (!user) return "";
    return user.name && user.name !== user.email ? `${user.name} (${user.email})` : user.email;
};

/** Iniciales para el hueco sin logo. */
export const initials = (text) => (
    String(text || "?")
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0]?.toUpperCase())
        .join("") || "?"
);

/** Teléfono para wa.me: solo dígitos y con 34 delante si es un número español de 9 cifras. */
export const whatsappDigits = (phone) => {
    let digits = String(phone || "").replace(/\D/g, "");
    if (digits.startsWith("00")) digits = digits.slice(2);
    if (digits.length === 9) digits = `34${digits}`;
    return digits;
};

/** El error de la API en una frase: el `detail` o "campo: motivo". */
export const apiErrorText = (error, fallback) => {
    const data = error?.response?.data;
    if (!data) return fallback;
    if (typeof data === "string") return fallback;
    if (data.detail) return data.detail;
    const first = Object.entries(data)[0];
    if (!first) return fallback;
    const [field, value] = first;
    const message = Array.isArray(value) ? value[0] : value;
    return field === "non_field_errors" ? String(message) : `${field}: ${typeof message === "object" ? JSON.stringify(message) : message}`;
};

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString("es-ES") : "");
